{
  "version": 1,
  "asset_id": "565625d7-522e-4197-a652-9649ebcd7524",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/565625d7-522e-4197-a652-9649ebcd7524/lap-band-removed-1600.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/565625d7-522e-4197-a652-9649ebcd7524/lap-band-removed-1600.webp",
  "original_filename": "lap-band-removed-1600.webp",
  "size": 127986,
  "content_type": "image/webp",
  "created_at": "2026-09-20T00:12:19Z"
}
